module.exports = __webpack_public_path__ + "r-v3/img/arrowLineThickLeft_white.be9598f6.svg";